const NewsList2020 = [
    {
        dt: "2020",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Flyer_AAMOS20.pdf",
        title: "AAMOS20 Flyer",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#nep",
        title: "Celebrating one year of National Education Policy 2020",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#phdV",
        title: "PhD Defense - Mr. Vinay HN",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#phdf",
        title: "PhD Defense - Mr. Avishreshth",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "https://files.iittp.ac.in/images/ProfKetterle-Talk.jpg",
        title: "IIT Tirupati and TCG-CQuERE MoU for research collaboration and doctoral program. Talk by Noble Laureate Prof. Ketterle",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#oxy",
        title: "Donation of Oxygen Concentrators by IIT Delhi Excellence Foundation Inc. to IIT Tirupati",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/downloads/Academic Prizes.pdf",
        title: "Best Academic Performers",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/AP HEPB Invitation.pdf",
        title: "Inauguration of AP Higher Education Planning Board",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "https://iittp.ac.in/annualreports",
        title: "Annual Report 2019-20",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#cyber",
        title: "Curbing Cybercrimes",
        desc: "The Ministry of Home Affairs (MHA) has setup the Indian Cyber Crime Coordination Center (I4C) to stregthen the capability of prevention, detection, investigation and prosecution of cyber crimes. Portal links:"
    },
    {
        dt: "2020",
        my: "",
        link: "https://www.youtube.com/watch?v=B5wxQU715Ec&feature=youtu.be",
        title: "Doctoral Fellowship in India for ASEAN",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#pmrf",
        title: "PMRF Fellowship",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#iitiiser",
        title: "IIT Tirupati and IISER Tirupati Inks MoU",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#poscu",
        title: "News on POCSU",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#camost",
        title: "Inaguration of CAMOST",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#tih",
        title: "Technology Innovation Hub",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "/pics/News_clip_BLAAST_Prototype.jpg",
        title: "A Novel Thermal Air Sterilizer - BLAAST",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#mobtrac",
        title: "News on mobility analysis to track COVID19",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#airpol",
        title: "News on AiR - Pollution Visualizer",
        desc: ""
    },
    {
        dt: "2020",
        my: "",
        link: "#nldi",
        title: "Person of the week of NLDI",
        desc: ""
    },
    {
        dt: "2020",
        my: "January",
        link: "https://iittp.ac.in/newsletter",
        title: "Newsletter January 2020",
        desc: "Volume 5, Issue 2 July 2022"
    }
];


export default NewsList2020;